import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Z_INDEX } from '@app/shared/styles/zIndex';

export const SkipLink: React.FC = () => {
  const { t } = useTranslation();

  return (
    <a
      href="#main-content"
      style={{
        clipPath: 'inset(100%)',
        position: 'absolute',
        zIndex: Z_INDEX.skipLink,
        padding: '12px 16px',
        background: '#1976d2',
        color: 'white',
        textDecoration: 'none',
        fontWeight: 'bold',
        fontSize: '16px',
        borderRadius: '4px',
        visibility: 'hidden',
      }}
      onFocus={e => e.target.style.visibility = 'visible'}
      onBlur={e => e.target.style.visibility = 'hidden'}
    >
      {t('accessibility.skip_to_main_content')}
    </a>
  );
};

